import {POST_ART_REQUEST, POST_ART_FAIL, POST_ART_SUCCESS, GET_ART_BY_USER_ID_REQUEST, GET_ART_BY_USER_ID_SUCCESS, GET_ART_BY_USER_ID_FAIL} from "./actionTypes"


export const postArtRequest = (formData, callback) => ({
    type: POST_ART_REQUEST,
    payload: { formData, callback },
  });
  
  export const postArtSuccess = () => ({
    type: POST_ART_SUCCESS,
  });
  
  export const postArtFail = (error) => ({
    type: POST_ART_FAIL,
    payload:error,
  });

  export const getArtByUserIdRequest = (user_id, callback) => ({
    type: GET_ART_BY_USER_ID_REQUEST,
    payload: { user_id, callback },
  });
  
  export const getArtByUserIdSuccess = (data) => ({
    type: GET_ART_BY_USER_ID_SUCCESS,
    payload:data
  });
  
  export const getArtByUserIdFail = (error) => ({
    type: GET_ART_BY_USER_ID_FAIL,
    payload:error,
  });